<div id="modal-content-wrapper">
    <header id="modal-header">
        <h1 i18n  id="modal-title">Delete file</h1>
    </header>
    <section id="modal-body">
        <p i18n  class="text">
            Are you sure you want to delete {{gedcomName}}?
        </p>

    </section>
    <footer id="modal-footer">
        <button i18n mat-raised-button id="modal-action-button" mat-dialog-close="success">
            OK
        </button>
        <button i18n mat-raised-button id="modal-cancel-button" (click)="closeModal()">
            Cancel
        </button>
    </footer>
</div>